import Entity, { fetchArray } from "entity";
import ReuniaoEntity from "entity/Reuniao";
import { ValidatorHelper } from "functions";
import { validarCPF, validarCEP, validarCelular, validarCNPJ } from "./functions";
import { clearAtributes } from "util/object";
import _ from "lodash";
import { sendEmail } from "modules/EmailControl";
import TemplateEmail from "modules/EmailControl/TemplateEmail";

export default class Inscricao extends Entity {
    static get collectionUID() {
        return "Inscricao";
    }

    static sendThankYouEmail(inscricaoData) {
        let nomeRodada = inscricaoData.rodada.nome
        let email = inscricaoData.empresa.funcionarios.email
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        if (!email || !emailRegex.test(email)) {

            console.log("E-mail inválido")
        } else {

            sendEmail(email, "Sistema de Rodadas - Confirmação de Inscrição", "Obrigado por se inscrever! - " + nomeRodada, TemplateEmail.generateThankYouEmail(inscricaoData))
        }
    }
    static async buscaInscricoesAntigas(cpfCnpj, rodadaUid) {
        return new Promise(async (resolve, reject) => {
            if (!rodadaUid) {
                resolve(null)
            }
            cpfCnpj = cpfCnpj.replace(/_/g, "")
            if (!cpfCnpj || cpfCnpj.length < 11) {
                resolve(null)

            } else if (cpfCnpj.length === 14) {
                if (!validarCPF(cpfCnpj.replace(/[.|_|-]/g, ""))) {
                    resolve(null)
                }
            } else if (cpfCnpj.length === 18) {
                if (!validarCNPJ((cpfCnpj).replace(/[^\d]+/g, ""))) {
                    resolve(null)
                }

            } else {
                resolve(null)
            }
            let query = await this.query();
            query = query.where("empresa.cnpj", "==", cpfCnpj);
            query = query.where("rodada.uid", "!=", rodadaUid);
            query = query.orderBy("rodada.uid").orderBy("dataLastChange");

            // query = query.where("status", "!=", "CANCELADO");
            fetchArray(query.get()).then((inscritos) => {
                resolve(inscritos)
            })

            // for (let i = 0; i < inscritos.length; i++) {
            //     if (inscritos[i].empresa.cnpj === values.empresa.cnpj && inscritos[i].uid !== values.uid) {
            //         return msgCnpjDuplicado;
            //     }
            // }

        })

    }

    async initialize() {
        this.data.status = "INSCRITO";
        this.data.statusEvento = "INSCRITO";
        this.data.empresa = {
            tipoPessoa: "CNPJ",
        };
    }
    static async onQuery(collection) {
        return collection; //.where("status", "==", "ATIVO").orderBy("nome");
    }
    async preSave(entity) {
        clearAtributes(entity.data, "rodada", ["uid", "nome"]);
    }
    static async validFieldErrors(values) {
        let v = new ValidatorHelper();

        v.addRequired("rodada", "Rodada");
        v.addRequired("tipo", "Tipo de Inscrição");
        v.addRequired("municipio", "Municipio");

        if (values.rodada.rodadaInternacional === "NÃO") {
            v.addRequired("empresa.tipoPessoa", "Tipo de Pessoa");
            v.addRequired("empresa.cnpj", "CNPJ/CPF da Empresa");
            v.addRequired("empresa.funcionarios.cpf", "CPF do Participante");
        }
        v.addRequired("empresa.nomeFantasia", "Nome Comercial");
        v.addRequired("empresa.nomeEmpresaCracha", "Nome da Empresa no Crachá");
        v.addRequired("empresa.descricaoEmpresa", "Descricao da Empresa");
        v.addRequired("empresa.funcionarios.nomeParticipante", "Nome do Participante");
        v.addRequired("empresa.funcionarios.celular", "Celular do Participante");

        let errorsMessage = v.valid(values);
        if (errorsMessage.length) {
            if (errorsMessage.length > 1) {
                return errorsMessage;
            }
        }

        if (
            (!values.empresa.produtosCompra || !values.empresa.produtosCompra.length) &&
            (!values.empresa.produtosVenda || !values.empresa.produtosVenda.length)
        ) {
            return ["Nenhum Produto/Serviço Selecionado"];
        }

        if (values.termo !== true) {
            return ["Aceite o Termo de Consentimento"];
        }

        if (values.empresa) {
            if (values.rodada.rodadaInternacional === "NÃO") {
                if (values.empresa.tipoPessoa === "CNPJ") {
                    if (!validarCNPJ(values.empresa.cnpj.replace(/[^\d]+/g, ""))) {
                        // this.data.empresa.cnpj = undefined
                        return ["CNPJ Inválido"];
                    }
                } else {
                    if (!validarCPF(values.empresa.cnpj?.replace(/[.|_|-]/g, ""))) {
                        return ["CPF da Inscrição Inválido"];
                    }
                }

                if (!validarCPF(values.empresa.funcionarios?.cpf?.replace(/[.|_|-]/g, ""))) {
                    return ["CPF do Participante é Inválido"];
                }
            }

            if (!validarCEP(values.empresa.cep?.replace(/[|_|-]/g, ""))) {
                return ["CEP da Empresa é Inválido "];
            }

            if (!validarCEP(values.empresa.funcionarios?.cep?.replace(/[|_|-]/g, ""))) {
                return ["CEP do Participante é Inválido "];
            }

            if (!validarCelular(values.empresa.funcionarios?.celular?.replace(/[|_|-]/g, "").replace(/\(|\)/g, ""))) {
                return ["Celular do Participante é Inválido"];
            }
        }

        const saveReunioes = async (values) => {
            let entity = new ReuniaoEntity();
            // console.log("reunião alterada", values)
            entity.update(values);

            entity
                .save()
                .then(() => {
                    console.log("reunião alterada com Sucesso");
                })
                .catch((e) => {
                    console.error(e.message);
                });
        };

        // reuniões da inscrição
        let query = await ReuniaoEntity.query();
        query = query.where("status", "==", "ATIVO");
        query = query.where("rodada.uid", "==", values.rodada.uid);
        let result = await fetchArray(query.get());
        result = result.filter((r) => r.inscricao1.uid === values.uid || r.inscricao2.uid === values.uid);
        if (values.statusEvento === "SAIU" || values.statusEvento === "AUSENTE" || values.status === "CANCELADO") {
            result.forEach((r) => {
                r.status = "INATIVO";
                saveReunioes(r);
            });
        } else {
            result.forEach((r) => {
                let newR = JSON.parse(JSON.stringify(r));
                if (newR.inscricao1.uid === values.uid) {
                    newR.inscricao1.statusEvento = values.statusEvento;
                    newR.inscricao1.status = values.status;
                    newR.inscricao1.empresa = values.empresa;
                    newR.inscricao1.empresa.funcionarios.nomeCracha = values.empresa.funcionarios.nomeCracha || "";
                } else {
                    newR.inscricao2.statusEvento = values.statusEvento;
                    newR.inscricao2.status = values.status;
                    newR.inscricao2.empresa = values.empresa;
                    newR.inscricao2.empresa.funcionarios.nomeCracha = values.empresa.funcionarios.nomeCracha || "";
                }
                if (!_.isEqual(newR, r)) {
                    saveReunioes(newR);
                }
            });
        }

        if (values.checkOutros) {
            // deixou checkbox marcado, mas não sugeriu nenhum produto
            if (typeof values.outrosProdutos === "object") {
                if (!(values.outrosProdutos || []).length) {
                    return ["Está marcado para sugerir produtos mas, nenhuma sugestão foi inserida."];
                    // values.checkOutros = false
                    // values.status = "INSCRITO"
                } else {
                    let cleanedList = [];
                    for (let i = 0; i < (values.outrosProdutos || []).length; i++) {
                        if (
                            values.outrosProdutos[i].group !== "" &&
                            values.outrosProdutos[i].name !== "" &&
                            values.outrosProdutos[i].description !== ""
                        ) {
                            cleanedList.push(values.outrosProdutos[i]);
                        }
                    }

                    // deixou checkbox marcado, mas todos os campos dos itens da lista estão vazios
                    if (!cleanedList.length) {
                        values.checkOutros = false;
                        values.status = "INSCRITO";
                    }
                    // eliminou os itens da lista que estão com todos os campos vazios
                    else {
                        values.outrosProdutos = cleanedList;

                        // tratando inscrição pública
                        // values.status = "PENDENTE/INSCRICAO"
                    }
                }
            } else if (typeof values.outrosProdutos === "string") {
                if (values.outrosProdutos.length === 0) {
                    return ["Está marcado para sugerir produtos mas, nenhuma sugestão foi inserida."];
                }
            }
        } else {
            // era string, mas o usuário cancelou a sugestão
            // na próxima vez será uma lista
            if (typeof values.outrosProdutos === "string" && values.outrosProdutos.length === 0) {
                values.outrosProdutos = [];
            }
        }

        // cadastro novo
        if (!values.dataLastChangeStr) {
            const dataAtual = new Date().toLocaleString("pt-BR", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
                hour: "2-digit",
                minute: "2-digit",
            });

            values.dataFirstChange = dataAtual;
        }
        // cadastro antigo sem o novo campo
        else if (!values.dataFirstChange) {
            values.dataFirstChange = values.dataLastChangeStr;
        }

        // if (values.rodada.rodadaInternacional === "NÃO") {
        if (values.rodada.bloqueiaCnpjDuplicado === "SIM") {
            let cnpjInscricao;
            let msgCnpjDuplicado;
            if (values.empresa.tipoPessoa === "CNPJ") {
                // RODADA T - 81.736.583/0001-15
                msgCnpjDuplicado = "CNPJ já cadastrado";
                cnpjInscricao = validarCNPJ((values.empresa?.cnpj || "").replace(/[^\d]+/g, ""));
            } else if (values.empresa.tipoPessoa === "CPF") {
                // RODADA T - 735.552.260-45
                msgCnpjDuplicado = "CPF de empresa já cadastrado";
                cnpjInscricao = validarCPF((values.empresa?.cnpj || "").replace(/[.|_|-]/g, ""));
            }

            if (cnpjInscricao) {
                let query = await this.query();
                query = query.where("rodada.uid", "==", values.rodada.uid);
                query = query.where("status", "!=", "CANCELADO");
                let inscritos = await fetchArray(query.get());

                for (let i = 0; i < inscritos.length; i++) {
                    if (inscritos[i].empresa.cnpj === values.empresa.cnpj && inscritos[i].uid !== values.uid) {
                        return msgCnpjDuplicado;
                    }
                }
            }
        }
        // }

        return null;
    }

    static get labelField() {
        return "empresa.nomeEmpresaCracha";
    }

    static get searchColumns() {
        return [
            { field: "rodada.nome", headerName: "RODADA", flex: 4, filter: true },
            { field: "empresa.nomeFantasia", headerName: "NOME DA EMPRESA", flex: 4, filter: true },
            { field: "tipo", headerName: "TIPO DE INSCRIÇÃO", flex: 1.5, filter: true },
            { field: "status", headerName: "STATUS", flex: 1, filter: true },
            { field: "statusEvento", headerName: "STATUS EVENTO", flex: 1.5, filter: true },
        ];
    }

    static get csvColumns() {
        return [
            {
                labelCol: "DATA DE CADASTRO",
                getValue: (inscricao) => {
                    return inscricao.dataFirstChange
                        ? _.get(inscricao, "dataFirstChange")
                        : _.get(inscricao, "dataLastChangeStr");
                },
            },
            { labelCol: "STATUS NO EVENTO", getValue: "statusEvento" },
            { labelCol: "TIPO DE INSCRIÇÃO", getValue: "tipo" },
            { labelCol: "NOME DA EMPRESA", getValue: "empresa.nomeFantasia", width: 60 },
            { labelCol: "CELULAR DO PARTICIPANTE", getValue: "empresa.funcionarios.celular" },
            { labelCol: "PARTICIPANTE", getValue: "empresa.funcionarios.nomeParticipante" },
            { labelCol: "PRODUTOS QUE VENDO", getValue: "produtosVendaStr" },
            { labelCol: "PRODUTOS QUE COMPRO", getValue: "produtosCompraStr" },
            { labelCol: "OUTROS PRODUTOS", getValue: "outrosProdutosStr" },
            { labelCol: "MESA", getValue: "mesa.name" },
            { labelCol: "RODADA", getValue: "rodada.nome" },
            { labelCol: "STATUS DA INSCRIÇÃO", getValue: "status" },
            { labelCol: "CNPJ/CPF DA EMPRESA", getValue: "empresa.cnpj" },
            { labelCol: "NOME DA EMPRESA NO CRACHÁ", getValue: "empresa.nomeEmpresaCracha" },
            { labelCol: "RAZÃO SOCIAL", getValue: "empresa.razaoSocial" },
            { labelCol: "ENDEREÇO", getValue: "empresa.endereco" },
            { labelCol: "MUNICÍPIO", getValue: "municipio" },
            { labelCol: "DESCRIÇÃO DA EMPRESA", getValue: "empresa.descricaoEmpresa" },
            { labelCol: "TELEFONE COMERCIAL DA EMPRESA", getValue: "empresa.telComercial" },
            { labelCol: "CELULAR DA EMPRESA", getValue: "empresa.celular" },
            { labelCol: "EMAIL", getValue: "empresa.email" },
            { labelCol: "FACEBOOK", getValue: "empresa.facebook" },
            { labelCol: "INSTAGRAM", getValue: "empresa.instagram" },
            { labelCol: "LINKEDIN", getValue: "empresa.linkedin" },
            { labelCol: "YOUTUBE", getValue: "empresa.youtube" },
            { labelCol: "SITE", getValue: "empresa.site" },
            { labelCol: "TWITTER", getValue: "empresa.twitter" },
            { labelCol: "CPF DO PARTICIPANTE", getValue: "empresa.funcionarios.cpf" },
            { labelCol: "NOME DO PARTICIPANTE NO CRACHÁ", getValue: "empresa.funcionarios.nomeCracha" },
            { labelCol: "SEXO", getValue: "empresa.funcionarios.sexo" },
            { labelCol: "TELEFONE COMERCIAL DO PARTICIPANTE", getValue: "empresa.funcionarios.telComercial" },
        ];
    }

    static get csvColumnsProdutosSugeridos() {
        return [
            { labelCol: "NOME DA EMPRESA", getValue: "empresa.nomeFantasia" },
            { labelCol: "PARTICIPANTE", getValue: "empresa.funcionarios.nomeParticipante" },
            { labelCol: "CEL. FUNC.", getValue: "empresa.funcionarios.celular" },
            { labelCol: "TEL. COMERCIAL  EMP.", getValue: "empresa.telComercial" },
            { labelCol: "CEL. EMP.", getValue: "empresa.celular" },
            { labelCol: "TEL. COMERCIAL FUNC.", getValue: "empresa.funcionarios.telComercial" },
            { labelCol: "OUTROS PRODUTOS", getValue: "outrosProdutosStr" },
        ];
    }
    static getUrlPainelInscrito(uidInscricao) {
        let host = window.location.origin
        let url = host + "/#/painel-inscrito?uid=" + uidInscricao
        // console.log("url ", url);
        return url
    }
}
